import store from '@/state/store'
import appConfig from "@/app.config";

export default async (to, from, next) => {

    const local = to.params.local;

    if(Array.isArray(appConfig.locales) && appConfig.locales.includes(local)){

        store.dispatch('layout/changeLocalValue', {local: local});
        next();
    }else{   
        next({name: "404"})
    }
}